<template>
  <v-card
    color="#ECEFF1"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-account-alert
      </v-icon> Select Users
    </h2>
    <br>
    <base-tree-view-without-actions
      :value="treeData"
      class="my-tree-view-style"
    >
      <span slot-scope="{node, path, tree}">
        <input
          id="myCheck"
          type="checkbox"
          :checked="node.$checked"
          @change="onCheckBoxChange(node, tree, path)"
        >
        {{ node.text }}
      </span>
    </base-tree-view-without-actions>
    <br>
    <br>
    <v-card-actions>
      <v-btn
        color="red darken-3"
        @click="cancelSending()"
      >
        Cancel
      </v-btn>
      <v-spacer />
      <v-btn
        class="mt-2"
        color="#FF3700"
        :disabled="!isServiceProviderSelected"
        @click="sendEmergencyMessage()"
      >
        Send
      </v-btn>
    </v-card-actions>
    <centre-spinner
      :loading="loading"
    />
  </v-card>
</template>
<script>

  import { walkTreeData } from 'he-tree-vue';
  import { getDefaultStructure, addMissingServiceProviders } from 'src/helpers/service-provider-structure-helper';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'SelectServiceProviders',
    components: {
      'centre-spinner': spinner,
    },
    props: {
        messageContents: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        selectedServiceProviders: [],
        treeData: [],
        loading: false,
      };
    },
    computed: {
      serviceProviders () {
        return this.$store.getters['serviceproviders/getServiceProviders'];
      },
      savedStructure () {
        return this.$store.getters['serviceproviders/getSavedServiceProvidersStructure'];
      },
      isServiceProviderSelected () {
        if (this.selectedServiceProviders.length > 0) {
          return true;
        }
        return false;
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchServiceProvidersSavedStructure();
      await this.fetchOrganizationServiceProviders();
      this.showTreeList();
      this.loading = false;
    },
    methods: {
      async fetchServiceProvidersSavedStructure () {
        await this.$store.dispatch('serviceproviders/fetchSavedServiceProvidersStructure');
      },
      async fetchOrganizationServiceProviders () {
        this.loading = true;
        await this.$store.dispatch('serviceproviders/fetchServiceProviders');
        this.loading = false;
      },
      showTreeList () {
        if (Object.keys(this.savedStructure).length <= 0) {
          const serviceProviders = this.serviceProviders;
          this.treeData = getDefaultStructure(serviceProviders);
          return;
        }
        const treeData = this.savedStructure.group;
        const serviceProviders = this.serviceProviders;
        this.treeData = addMissingServiceProviders(treeData, serviceProviders);
      },
      onCheckBoxChange (node, tree, path) {
        tree.toggleCheck(node, path);
        const selectedNodes = [];
        tree.walkTreeData((node) => {
          node.$checked && selectedNodes.push(node);
        });
        this.selectedServiceProviders = selectedNodes;
      },
      sendEmergencyMessage () {
        this.loading = true;
        const selectedOrgServiceProviderIds = [];
        walkTreeData(this.treeData, (node) => {
          if (node.$checked && node.id !== undefined) {
            selectedOrgServiceProviderIds.push(node.id);
          }
        });
        this.$store.dispatch('widgets/sendEmergencyMessage', {
          emergencyMessage: {
            title: this.messageContents.title,
            description: this.messageContents.description,
            contractors: selectedOrgServiceProviderIds,
          },
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Message send successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('message-send');
        });
      },
      cancelSending () {
        this.$emit('sending-cancelled');
      },
    },
  };
</script>
<style scoped>
.my-tree-view-style {
  margin-left: 30px;
}
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
input[type="checkbox"] {
accent-color: #FF3700
}
</style>
